/**
 * Created by andrey on 04.03.2021.
 */

cc.isoRectGetCenter = function (rect) {
    return cc.p( 
        Math.round(rect.x + rect.width / 2 + rect.height / 2),
        Math.round(rect.y + rect.width / 2 - rect.height / 2)
    );
};

cc.isoRectContainsPoint = function (rect, x, y) {
    const dx = x - rect.x;
    const dy = y - rect.y;

    const tx = (dx + dy) / 2;
    const ty = (dx - dy) / 2;

    return tx >= 0 && tx <= rect.width && ty >= 0 && ty <= rect.height;
};

cc.iterateIsoRect = function (rect, iterator) {
    for (let dy = rect.height; dy >= 0; dy -= 0.5) {
        const startX = rect.x + Math.floor(dy);
        const startY = rect.y - Math.ceil(dy);

        for (let dx = rect.width; dx >= 0; dx--) {
            iterator(startX + dx, startY + dx);
        }
    }
};

cc.isoRectComparator = function (a, b) {
    return (b.x - b.y) - (a.x - a.y) || (b.x + b.y) - (a.x + a.y);
};
